/* Prints a standalone HTML document through a hidden same-origin iframe. A popup from
   `window.open("")` is not scriptable on iOS Safari, so writing into it throws a
   cross-origin SecurityError. The iframe is removed once printing is over. */
export const printHtml = (html: string): void => {
  const iframe = document.createElement("iframe");
  iframe.setAttribute("aria-hidden", "true");
  iframe.style.cssText = "position: fixed; top: 0; left: -10000px; width: 100vw; height: 100vh; border: 0;";

  iframe.onload = () => printFrame(iframe);
  iframe.srcdoc = html;
  document.body.appendChild(iframe);
};

const printFrame = (iframe: HTMLIFrameElement): void => {
  iframe.onload = null;

  const frameWindow = iframe.contentWindow;
  if (!frameWindow) {
    iframe.remove();
    return;
  }

  frameWindow.addEventListener("afterprint", () => iframe.remove(), { once: true });
  frameWindow.focus();
  frameWindow.print();
};
